import {useMutation, useQueryClient} from '@tanstack/react-query';
import brandNegotiationsUpdaters from '@/api/updaters/brandNegotiations';
import {CAMPAIGN_CONVERSATION_MESSAGES_QUERY_KEY} from '@/hooks/queries/use-campaign-conversation-messages';
import {CONVERSATION_MESSAGES_QUERY_KEY} from '@/hooks/queries/use-conversation-messages-query';
import {PAID_GIG_QUERY_KEY} from '@/hooks/queries/use-paid-gig-query';

function useWithdrawBrandNegotiation({paidGigId}: {paidGigId: string | null}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['brandNegotiations', 'withdraw'],
    mutationFn: brandNegotiationsUpdaters.withdraw,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CONVERSATION_MESSAGES_QUERY_KEY],
      });
      queryClient.resetQueries({
        queryKey: [CAMPAIGN_CONVERSATION_MESSAGES_QUERY_KEY, 'messages'],
      });
      queryClient.invalidateQueries({
        queryKey: [PAID_GIG_QUERY_KEY, paidGigId],
      });
    },
  });
}

export default useWithdrawBrandNegotiation;
